import {
  Module, ActionTree, MutationTree, GetterTree
} from 'vuex';
import { readCookie, writeCookie, removeCookie } from '@/tools/tools';
import { AddressState } from './types';
import { RootState } from '../types';
/**
 * getters
 */
export const getters: GetterTree<AddressState, RootState> = {
  addresslist: (state: AddressState) => state.addresslist
};

/**
 * mutations
 */
export const mutations: MutationTree<AddressState> = {
  // 收货列表
  ADDRESSLIST(state: AddressState, payload: []) {
    state.addresslist = payload;
    writeCookie('addresslist', state.addresslist);
  },
  // 编辑收货地址
  ADDRESSEDIT(state: AddressState, payload: []) {
    state.addressedit = payload;
    writeCookie('addressedit', state.addressedit);
  },
  // 新增时清空当前编辑地址
  CLEAREDITADDRESS(state: AddressState) {
    state.addressedit = {};
    writeCookie('addressedit', state.addressedit);
  },
  // 清空选择地址
  CLEARESELECTADDRESS(state: AddressState) {
    state.addressselect = [];
  },
  // 选择收货地址
  SELECTADDRESS(state: AddressState, payload: []) {
    state.addressselect = payload;
  }
};

/**
 * actions
 */
export const actions: ActionTree<AddressState, RootState> = {
  async setAddressList({ commit }, payload: []) {
    commit('ADDRESSLIST', payload);
  },
  addressEdit({ commit }, payload: []) {
    commit('ADDRESSEDIT', payload);
  },
  clearEditAddress({ commit }) {
    commit('CLEAREDITADDRESS');
  }
};
/**
 * state
 */
export const state: AddressState = {
  addresslist: readCookie('addresslist') ? readCookie('addresslist') : [],
  addressedit: readCookie('addressedit'),
  addressselect: []
};
const namespaced: boolean = true;

export const address: Module<AddressState, RootState> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
